import * as types from '../../actions/school-candidate/types';
import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import schoolCandidateProfileStateKeys from '../../constants/school-candidate-profile-state-keys';

const initialState = Immutable.fromJS({
  [schoolCandidateProfileStateKeys.biographicalInformation]: null,
  [schoolCandidateProfileStateKeys.health]: null,
  [schoolCandidateProfileStateKeys.housingPreferences]: null,
  [schoolCandidateProfileStateKeys.sportActivities]: null,
  [schoolCandidateProfileStateKeys.languages]: null,
  [schoolCandidateProfileStateKeys.personal]: null,
  [schoolCandidateProfileStateKeys.teachingCredentials]: null,
  [schoolCandidateProfileStateKeys.teachingExperience]: null,
  [schoolCandidateProfileStateKeys.universitiesColleges]: null,
  [schoolCandidateProfileStateKeys.secondarySchools]: null,
  [schoolCandidateProfileStateKeys.contactInformation]: null,
  [schoolCandidateProfileStateKeys.documents]: null,

  [schoolCandidateProfileStateKeys.isBiographicalInformationLoading]: false,
  [schoolCandidateProfileStateKeys.isHealthLoading]: false,
  [schoolCandidateProfileStateKeys.isHousingPreferencesLoading]: false,
  [schoolCandidateProfileStateKeys.isLanguagesLoading]: false,
  [schoolCandidateProfileStateKeys.isPersonalLoading]: false,
  [schoolCandidateProfileStateKeys.isSecondarySchoolsLoading]: false,
  [schoolCandidateProfileStateKeys.isSportActivitiesLoading]: false,
  [schoolCandidateProfileStateKeys.isTeachingCredentialsLoading]: false,
  [schoolCandidateProfileStateKeys.isTeachingExperienceLoading]: false,
  [schoolCandidateProfileStateKeys.isUniversitiesCollegesLoading]: false,
  [schoolCandidateProfileStateKeys.isContactInformationLoading]: false,
  [schoolCandidateProfileStateKeys.isDocumentsLoading]: false
});

export default reducerCreator(initialState, {
  [types.SCHOOL_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION]: (state, { biographicalInformation }) =>
    state.set(schoolCandidateProfileStateKeys.biographicalInformation, Immutable.fromJS(biographicalInformation)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_HEALTH]: (state, { health }) =>
    state.set(schoolCandidateProfileStateKeys.health, Immutable.fromJS(health)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES]: (state, { housingPreferences }) =>
    state.set(schoolCandidateProfileStateKeys.housingPreferences, Immutable.fromJS(housingPreferences)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_LANGUAGES]: (state, { languages }) =>
    state.set(schoolCandidateProfileStateKeys.languages, Immutable.fromJS(languages)),
  
  [types.SCHOOL_CANDIDATE_PROFILE_SET_PERSONAL]: (state, { personal }) =>
    state.set(schoolCandidateProfileStateKeys.personal, Immutable.fromJS(personal)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS]: (state, { secondarySchools }) =>
    state.set(schoolCandidateProfileStateKeys.secondarySchools, Immutable.fromJS(secondarySchools)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES]: (state, { sportActivities }) =>
    state.set(schoolCandidateProfileStateKeys.sportActivities, Immutable.fromJS(sportActivities)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS]: (state, { teachingCredentials }) =>
    state.set(schoolCandidateProfileStateKeys.teachingCredentials, Immutable.fromJS(teachingCredentials)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE]: (state, { teachingExperience }) =>
    state.set(schoolCandidateProfileStateKeys.teachingExperience, Immutable.fromJS(teachingExperience)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES]: (state, { universitiesColleges }) =>
    state.set(schoolCandidateProfileStateKeys.universitiesColleges, Immutable.fromJS(universitiesColleges)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION]: (state, { contactInformation }) =>
    state.set(schoolCandidateProfileStateKeys.contactInformation, Immutable.fromJS(contactInformation)),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_DOCUMENTS]: (state, { documents }) =>
    state.set(schoolCandidateProfileStateKeys.documents, Immutable.fromJS(documents)),



  [types.SCHOOL_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isBiographicalInformationLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_HEALTH_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isHealthLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isHousingPreferencesLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_LANGUAGES_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isLanguagesLoading, isLoading),
  
  [types.SCHOOL_CANDIDATE_PROFILE_SET_PERSONAL_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isPersonalLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isSecondarySchoolsLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isSportActivitiesLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isTeachingCredentialsLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isTeachingExperienceLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isUniversitiesCollegesLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isContactInformationLoading, isLoading),

  [types.SCHOOL_CANDIDATE_PROFILE_SET_DOCUMENTS_LOADING]: (state, { isLoading }) =>
    state.set(schoolCandidateProfileStateKeys.isDocumentsLoading, isLoading)
});


// WEBPACK FOOTER //
// ./src/reducers/school/school-candidate-profile.js